export const ORP_SETPOINT_RESOLUTION = { min: 350, max: 980, step: 5 };
export const CELL_OUTPUT_RESOLUTION = { min: 0, max: 100, step: 5 };

/**
 * Snap a typed setpoint onto the Lifeguard step grid.
 * 572 mV with a 5 mV step and a 350 mV minimum becomes 570.
 */
export function snapToStep(
  value: number,
  step: number,
  min?: number,
  max?: number,
): number {
  if (!Number.isFinite(value) || !Number.isFinite(step) || step <= 0) {
    return value;
  }

  const origin = min ?? 0;
  const steps = Math.round((value - origin) / step);
  let snapped = origin + steps * step;
  if (min != null && snapped < min) snapped = min;
  if (max != null && snapped > max) snapped = max;

  const decimals = decimalPlaces(step);
  return Number(snapped.toFixed(decimals));
}

interface LifeguardSetpoints {
  orpSetpoint: number;
  setCellOutput: number;
}

export function alignLifeguardSetpoints<T extends LifeguardSetpoints>(
  params: T,
): T {
  return {
    ...params,
    orpSetpoint: snapToStep(
      params.orpSetpoint,
      ORP_SETPOINT_RESOLUTION.step,
      ORP_SETPOINT_RESOLUTION.min,
      ORP_SETPOINT_RESOLUTION.max,
    ),
    setCellOutput: snapToStep(
      params.setCellOutput,
      CELL_OUTPUT_RESOLUTION.step,
      CELL_OUTPUT_RESOLUTION.min,
      CELL_OUTPUT_RESOLUTION.max,
    ),
  };
}

function decimalPlaces(step: number): number {
  const text = step.toString();
  const dot = text.indexOf(".");
  return dot === -1 ? 0 : text.length - dot - 1;
}
